// Settings page (layouts/settings) texts. Looked up by LanguageContext after the main translations.
const settingsTranslations = {
  en: {
    stTitle: "Settings",
    stSubtitle: "All settings in one place",
    stTabGeneral: "General",
    stTabCompany: "Company",
    stTabReceipt: "Document receipt",
    stTabRecognition: "Recognition (AI)",
    stTabApiKeys: "API keys",
    stTabModels: "Models",
    stRecognitionOptionsHint: "Used every time documents of this company are recognised.",
    stModelsHint:
      'Models for all companies ({count}). Only sections marked "Apply to all companies" are saved – other company-specific settings stay as they are. A single company can still be changed in the "Recognition (AI)" tab.',
    stModelsDiffer:
      "Companies use different settings in this section now. The values shown are used by most companies.",
    stApplyToAll: "Apply to all companies ({count})",
    stTabUsers: "Users",
    stCompanyScope: "Settings of company",
    stCompanyScopeHint: "Settings in this tab apply only to the selected company.",
    stAllCompaniesScope: "Shared by all companies",
    stSave: "Save",
    stSaving: "Saving…",
    stSaved: "Settings saved",
    stSaveFailed: "Failed to save settings",
    stLoadFailed: "Failed to load settings",
    stUnsavedChanges: "Unsaved changes",
    stNoChanges: "No changes",
    stSelectCompany: "Select a company first",
    // General
    stInterface: "Interface",
    stInterfaceHint: "Stored in this browser only.",
    stAccount: "Account",
    stAccountHint: "Your login details.",
    // Company
    stCompanyDetails: "Company details",
    stCompanyDetailsHint: "Name and code are used to recognise the buyer on invoices.",
    stCompanyNameRequired: "Company name is required",
    stCompanyCodeHint: "Company registration code (9 digits)",
    stDescriptionHint: "Internal note, visible only in DVS",
    stManageCompanies: "Add or remove companies",
    // Receipt
    stInbox: "E-mail inbox",
    stInboxHint: "Invoices sent to this address are imported automatically every 2 minutes.",
    stInboxEmailHint: "Leave empty if this company does not receive invoices by e-mail",
    stFormats: "Accepted files",
    stExtensionsHint: "Comma separated, e.g. .pdf,.png,.jpg",
    stSenders: "Allowed senders",
    stSendersHint:
      "One e-mail address or domain per line (e.g. buhalterija@tiekejas.lt or @tiekejas.lt). Empty – any sender.",
    stSplitTitle: "Multi-page PDF files",
    stSplitHint:
      "When on, PDF files with several pages wait in “PDF splitting” – one file may contain several invoices.",
    stCheckInbox: "Check inbox now",
    // Recognition
    stRecognitionHint:
      "How documents of this company are recognised. API keys are in the “API keys” tab.",
    stMainModel: "Recognition model",
    stMainModelHint: "Model that extracts invoice data.",
    stProvider: "Provider",
    stModelVersion: "Model version",
    stCuAnalyzer: "Content Understanding analyzer",
    stValidation: "Additional check",
    stValidationHint:
      "A second model checks the result – more accurate, but slower and more expensive.",
    stValidationMode: "Mode",
    stValidationOff: "Off",
    stValidationTargeted: "Only when totals do not match (recommended)",
    stValidationDual: "Always – two models (dual-pass)",
    stPrimaryModel: "First model",
    stValidationModel: "Checking model",
    stProductMatching: "Product matching",
    stProductMatchingHint: "Model that matches invoice lines to warehouse products.",
    stVision: "OpenAI Vision",
    stVisionHint:
      "Send the document image to OpenAI instead of Azure text recognition (only with OpenAI).",
    stVisionUse: "Use OpenAI Vision",
    stPrompts: "Instructions for the model",
    stPromptsHint:
      "Change only if you know what you are doing – they affect all recognition of this company.",
    stImportFrom: "Copy from another company",
    // API keys
    stApiKeysHint:
      "Keys are the same for all companies. Saving updates every company ({count}). Leave a field unchanged to keep the current key.",
    stApiKeysDiffer:
      "These values differ between companies now: {fields}. Saving will make them the same everywhere.",
    stShow: "Show",
    stHide: "Hide",
    stAzure: "Azure Document Intelligence",
    stContentUnderstanding: "Azure Content Understanding",
    stLlmProviders: "Language models",
    stEndpoint: "Endpoint",
    stApiKey: "API key",
    stAdminOnly: "Only administrators can see this tab.",
    // Users
    umSearch: "Search by name or e-mail",
    umAllCompanies: "All companies",
    umAllStatuses: "All",
    umActiveOnly: "Active",
    umInactiveOnly: "Inactive",
    umCount: "Users: {count}",
    umAdd: "Add user",
    umNoUsers: "No users match the filters",
    umEveryCompany: "All companies ({count})",
    umNoCompany: "No company",
    umCompaniesCount: "{count} companies",
    umLastLogin: "Last login",
    umNeverLoggedIn: "Never logged in",
    umYou: "you",
    umEdit: "Edit",
    umSetPassword: "Set password",
    umDeactivate: "Deactivate",
    umActivate: "Activate",
    umActive: "Active",
    umInactive: "Inactive",
    umCreateTitle: "New user",
    umEditTitle: "Edit user",
    umDetails: "Details",
    umEmail: "E-mail",
    umFirstName: "First name",
    umLastName: "Last name",
    umPassword: "Password",
    umPasswordHint: "At least 8 characters. The user can change it later.",
    umRole: "Role",
    umRoleAdmin: "Administrator",
    umRoleAdminHint: "Manages users, API keys and all settings.",
    umRoleUser: "User",
    umRoleUserHint: "Works with documents of the assigned companies.",
    umRoleGuest: "Guest",
    umRoleGuestHint: "Currently the same rights as a user.",
    umStatusLabel: "Can log in",
    umCompanies: "Companies",
    umCompaniesHint: "The user sees only the selected companies.",
    umSelected: "Selected {count}/{total}",
    umSelectAll: "Select all",
    umSelectNone: "Clear",
    umFilterCompanies: "Find a company",
    umSave: "Save",
    umCancel: "Cancel",
    umCreate: "Create user",
    umSaved: "User saved",
    umCreated: "User created",
    umPasswordSaved: "Password changed",
    umNewPassword: "New password",
    umRepeatPassword: "Repeat password",
    umPasswordsDiffer: "Passwords do not match",
    umEmailRequired: "Enter e-mail",
    umFailed: "Action failed",
  },
  lt: {
    stTitle: "Nustatymai",
    stSubtitle: "Visi nustatymai vienoje vietoje",
    stTabGeneral: "Bendrieji",
    stTabCompany: "Įmonė",
    stTabReceipt: "Dokumentų gavimas",
    stTabRecognition: "Atpažinimas (AI)",
    stTabApiKeys: "API raktai",
    stTabModels: "Modeliai",
    stRecognitionOptionsHint: "Taikoma kiekvieną kartą atpažįstant šios įmonės dokumentus.",
    stModelsHint:
      "Modeliai visoms įmonėms ({count}). Išsaugomos tik sekcijos, pažymėtos „Taikyti visoms įmonėms“ – kiti įmonių nustatymai nesikeičia. Vienos įmonės modelį vis dar galima pakeisti skirtuke „Atpažinimas (AI)“.",
    stModelsDiffer:
      "Šiuo metu įmonės šioje sekcijoje naudoja skirtingus nustatymus. Rodomos daugumos įmonių naudojamos reikšmės.",
    stApplyToAll: "Taikyti visoms įmonėms ({count})",
    stTabUsers: "Naudotojai",
    stCompanyScope: "Įmonės nustatymai",
    stCompanyScopeHint: "Šio skirtuko nustatymai taikomi tik pasirinktai įmonei.",
    stAllCompaniesScope: "Bendri visoms įmonėms",
    stSave: "Išsaugoti",
    stSaving: "Saugoma…",
    stSaved: "Nustatymai išsaugoti",
    stSaveFailed: "Nepavyko išsaugoti nustatymų",
    stLoadFailed: "Nepavyko įkelti nustatymų",
    stUnsavedChanges: "Yra neišsaugotų pakeitimų",
    stNoChanges: "Pakeitimų nėra",
    stSelectCompany: "Pirmiausia pasirinkite įmonę",
    // Bendrieji
    stInterface: "Sąsaja",
    stInterfaceHint: "Išsaugoma tik šioje naršyklėje.",
    stAccount: "Paskyra",
    stAccountHint: "Jūsų prisijungimo duomenys.",
    // Įmonė
    stCompanyDetails: "Įmonės rekvizitai",
    stCompanyDetailsHint: "Pavadinimas ir kodas naudojami atpažįstant pirkėją sąskaitose.",
    stCompanyNameRequired: "Įveskite įmonės pavadinimą",
    stCompanyCodeHint: "Įmonės kodas (9 skaitmenys)",
    stDescriptionHint: "Vidinė pastaba, matoma tik DVS",
    stManageCompanies: "Pridėti ar pašalinti įmones",
    // Gavimas
    stInbox: "El. pašto dėžutė",
    stInboxHint: "Į šį adresą atsiųstos sąskaitos importuojamos automatiškai kas 2 minutes.",
    stInboxEmailHint: "Palikite tuščią, jei įmonė sąskaitų paštu negauna",
    stFormats: "Priimami failai",
    stExtensionsHint: "Atskirkite kableliais, pvz. .pdf,.png,.jpg",
    stSenders: "Leidžiami siuntėjai",
    stSendersHint:
      "Po vieną el. pašto adresą ar domeną eilutėje (pvz. buhalterija@tiekejas.lt arba @tiekejas.lt). Tuščia – bet kuris siuntėjas.",
    stSplitTitle: "Kelių puslapių PDF failai",
    stSplitHint:
      "Įjungus kelių puslapių PDF laukia „PDF skaidyme“ – viename faile gali būti kelios sąskaitos.",
    stCheckInbox: "Patikrinti paštą dabar",
    // Atpažinimas
    stRecognitionHint:
      "Kaip atpažįstami šios įmonės dokumentai. API raktai – skirtuke „API raktai“.",
    stMainModel: "Atpažinimo modelis",
    stMainModelHint: "Modelis, kuris ištraukia sąskaitos duomenis.",
    stProvider: "Tiekėjas",
    stModelVersion: "Modelio versija",
    stCuAnalyzer: "Content Understanding analizatorius",
    stValidation: "Papildoma patikra",
    stValidationHint: "Antras modelis patikrina rezultatą – tiksliau, bet lėčiau ir brangiau.",
    stValidationMode: "Režimas",
    stValidationOff: "Išjungta",
    stValidationTargeted: "Tik kai nesutampa sumos (rekomenduojama)",
    stValidationDual: "Visada – du modeliai (dual-pass)",
    stPrimaryModel: "Pirmas modelis",
    stValidationModel: "Tikrinantis modelis",
    stProductMatching: "Prekių atitikimas",
    stProductMatchingHint: "Modelis, kuris sąskaitos eilutes susieja su sandėlio prekėmis.",
    stVision: "OpenAI Vision",
    stVisionHint:
      "Siųsti dokumento vaizdą į OpenAI vietoj Azure teksto atpažinimo (tik su OpenAI).",
    stVisionUse: "Naudoti OpenAI Vision",
    stPrompts: "Instrukcijos modeliui",
    stPromptsHint: "Keiskite tik žinodami, ką darote – jos lemia visą šios įmonės atpažinimą.",
    stImportFrom: "Kopijuoti iš kitos įmonės",
    // API raktai
    stApiKeysHint:
      "Raktai vienodi visoms įmonėms. Išsaugojus atnaujinama kiekviena įmonė ({count}). Nekeiskite lauko – liks esamas raktas.",
    stApiKeysDiffer:
      "Šiuo metu šios reikšmės įmonėse skiriasi: {fields}. Išsaugojus jos bus suvienodintos.",
    stShow: "Rodyti",
    stHide: "Slėpti",
    stAzure: "Azure Document Intelligence",
    stContentUnderstanding: "Azure Content Understanding",
    stLlmProviders: "Kalbos modeliai",
    stEndpoint: "Adresas (endpoint)",
    stApiKey: "API raktas",
    stAdminOnly: "Šį skirtuką mato tik administratoriai.",
    // Naudotojai
    umSearch: "Ieškoti pagal vardą ar el. paštą",
    umAllCompanies: "Visos įmonės",
    umAllStatuses: "Visi",
    umActiveOnly: "Aktyvūs",
    umInactiveOnly: "Išjungti",
    umCount: "Naudotojų: {count}",
    umAdd: "Pridėti naudotoją",
    umNoUsers: "Pagal filtrus naudotojų nerasta",
    umEveryCompany: "Visos įmonės ({count})",
    umNoCompany: "Nepriskirta įmonių",
    umCompaniesCount: "Įmonių: {count}",
    umLastLogin: "Paskutinis prisijungimas",
    umNeverLoggedIn: "Dar neprisijungė",
    umYou: "jūs",
    umEdit: "Redaguoti",
    umSetPassword: "Nustatyti slaptažodį",
    umDeactivate: "Išjungti prisijungimą",
    umActivate: "Įjungti prisijungimą",
    umActive: "Aktyvus",
    umInactive: "Išjungtas",
    umCreateTitle: "Naujas naudotojas",
    umEditTitle: "Naudotojo redagavimas",
    umDetails: "Duomenys",
    umEmail: "El. paštas",
    umFirstName: "Vardas",
    umLastName: "Pavardė",
    umPassword: "Slaptažodis",
    umPasswordHint: "Bent 8 simboliai. Naudotojas vėliau galės jį pasikeisti.",
    umRole: "Rolė",
    umRoleAdmin: "Administratorius",
    umRoleAdminHint: "Valdo naudotojus, API raktus ir visus nustatymus.",
    umRoleUser: "Naudotojas",
    umRoleUserHint: "Dirba su priskirtų įmonių dokumentais.",
    umRoleGuest: "Svečias",
    umRoleGuestHint: "Šiuo metu teisės tokios pat kaip naudotojo.",
    umStatusLabel: "Gali prisijungti",
    umCompanies: "Įmonės",
    umCompaniesHint: "Naudotojas mato tik pažymėtas įmones.",
    umSelected: "Pažymėta {count}/{total}",
    umSelectAll: "Pažymėti visas",
    umSelectNone: "Nuimti visas",
    umFilterCompanies: "Rasti įmonę",
    umSave: "Išsaugoti",
    umCancel: "Atšaukti",
    umCreate: "Sukurti naudotoją",
    umSaved: "Naudotojas išsaugotas",
    umCreated: "Naudotojas sukurtas",
    umPasswordSaved: "Slaptažodis pakeistas",
    umNewPassword: "Naujas slaptažodis",
    umRepeatPassword: "Pakartokite slaptažodį",
    umPasswordsDiffer: "Slaptažodžiai nesutampa",
    umEmailRequired: "Įveskite el. paštą",
    umFailed: "Veiksmas nepavyko",
  },
};

export default settingsTranslations;
